import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';

function List() {

    const pathFrontEnd = '/propertytypes/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}propertytypes/delete`,
        endpoint: config.endpoints.backend + 'propertytypes/getall'
    }

    let list = {
        labelTitle: 'Lista de Tipos de Patrimônios',
        labelTitleButtonAdd: 'Incluir novo tipo',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        columns: [
            {
                name: 'name',
                label: 'Nome do tipo de ajuste'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
